import { formatDistanceToNow } from 'date-fns';

// Shared between the navbar bell dropdown and the full Alerts page.
export const TYPE_BADGES = {
  sponsorship_new: { bg: 'primary', label: 'Sponsorship' },
  renewal_upcoming: { bg: 'info', label: 'Renewal' },
  payment_failed: { bg: 'danger', label: 'Payment' },
  sponsorship_lapsed: { bg: 'warning', label: 'Lapsed' },
  child_unavailable: { bg: 'secondary', label: 'Beneficiary' },
  report_overdue: { bg: 'warning', label: 'Reports' },
  pledge_due: { bg: 'success', label: 'Pledge' },
  pack_not_sent: { bg: 'secondary', label: 'Pack' },
  enrolment_ended: { bg: 'warning', label: 'Enrolment' },
  facility_closed: { bg: 'danger', label: 'Facility' },
  payment_check: { bg: 'info', label: 'Payment check' },
  reminder_overdue: { bg: 'warning', label: 'Reminder' }
};

export const TYPE_OPTIONS = Object.entries(TYPE_BADGES).map(
  ([value, { label }]) => ({ value, label })
);

// What staff should do about an alert of this type. Shown under the body so
// the action is explicit even for alerts generated before the text existed.
export const TYPE_GUIDANCE = {
  child_unavailable:
    'Check whether this child is assigned to a sponsor and reassign a new child to the sponsor if required.',
  sponsorship_lapsed:
    'Contact the sponsor, or find a replacement sponsor for this child.',
  payment_check:
    "Check the payment has cleared and manually add the payment in the donor's Giving profile.",
  reminder_overdue:
    'Open Reminders to complete it, or reopen and reassign it to the right person.'
};

export const getBadge = type =>
  TYPE_BADGES[type] || { bg: 'secondary', label: 'Alert' };

export const timeAgo = date =>
  date ? formatDistanceToNow(new Date(date), { addSuffix: true }) : '';
